/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_BookingFormDetailDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_BookingFormDetailDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_BookingFormDetailExternalDTO } from '../models/Routemize_DTOs_BookingFormDetailExternalDTO';
import type { Routemize_DTOs_BookingFormDto } from '../models/Routemize_DTOs_BookingFormDto';
import type { Routemize_DTOs_BookingFormDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_BookingFormDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_BookingFormFullDetailDTO } from '../models/Routemize_DTOs_BookingFormFullDetailDTO';
import type { Routemize_DTOs_BookingFormRequestDTO } from '../models/Routemize_DTOs_BookingFormRequestDTO';
import type { Routemize_DTOs_CheckSlugAvailabilityRequest } from '../models/Routemize_DTOs_CheckSlugAvailabilityRequest';
import type { Routemize_DTOs_CreateBookingFormDto } from '../models/Routemize_DTOs_CreateBookingFormDto';
import type { Routemize_DTOs_SearchParameters_BookingFormSearchFilter_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_SearchParameters_BookingFormSearchFilter_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1 } from '../models/Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1';
import type { Routemize_DTOs_SetBookingFormDirectoryInput } from '../models/Routemize_DTOs_SetBookingFormDirectoryInput';
import type { Routemize_DTOs_SlugAvailabilityDto } from '../models/Routemize_DTOs_SlugAvailabilityDto';
import type { Routemize_DTOs_UpdateBookingFormDto } from '../models/Routemize_DTOs_UpdateBookingFormDto';
import type { Routemize_DTOs_UpdateBookingFormRequestDTO } from '../models/Routemize_DTOs_UpdateBookingFormRequestDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BookingFormService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormDto OK
     * @throws ApiError
     */
    public static postApiAppBookingFormCreate(
        requestBody?: Routemize_DTOs_CreateBookingFormDto,
    ): CancelablePromise<Routemize_DTOs_BookingFormDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_BookingFormDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppBookingFormGetList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingForm/getList',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppBookingFormDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/bookingForm/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_BookingFormDto OK
     * @throws ApiError
     */
    public static getApiAppBookingFormGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_BookingFormDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingForm/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormDto OK
     * @throws ApiError
     */
    public static putApiAppBookingFormUpdate(
        requestBody?: Routemize_DTOs_UpdateBookingFormDto,
    ): CancelablePromise<Routemize_DTOs_BookingFormDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/bookingForm/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormDto OK
     * @throws ApiError
     */
    public static postApiAppBookingFormCreateForm(
        requestBody?: Routemize_DTOs_BookingFormRequestDTO,
    ): CancelablePromise<Routemize_DTOs_BookingFormDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/createForm',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormDto OK
     * @throws ApiError
     */
    public static putApiAppBookingFormUpdateForm(
        requestBody?: Routemize_DTOs_UpdateBookingFormRequestDTO,
    ): CancelablePromise<Routemize_DTOs_BookingFormDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/bookingForm/updateForm',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param bookingFormId
     * @returns Routemize_DTOs_BookingFormFullDetailDTO OK
     * @throws ApiError
     */
    public static getApiAppBookingFormGetFullDetail(
        bookingFormId: string,
    ): CancelablePromise<Routemize_DTOs_BookingFormFullDetailDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingForm/getFullDetail/{bookingFormId}',
            path: {
                'bookingFormId': bookingFormId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_BookingFormDetailDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static postApiAppBookingFormSearch(
        requestBody?: Routemize_DTOs_SearchParameters_PagedSortedAndFilteredRequestDto_1,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param bookingFormId
     * @returns Routemize_DTOs_BookingFormDetailExternalDTO OK
     * @throws ApiError
     */
    public static getApiAppBookingFormGetBookingFormDetail(
        bookingFormId: string,
    ): CancelablePromise<Routemize_DTOs_BookingFormDetailExternalDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingForm/getBookingFormDetail/{bookingFormId}',
            path: {
                'bookingFormId': bookingFormId,
            },
        });
    }
    /**
     * @param allowInstantBooking
     * @returns Routemize_DTOs_BookingFormDto OK
     * @throws ApiError
     */
    public static getApiAppBookingFormGetAllForms(
        allowInstantBooking?: boolean,
    ): CancelablePromise<Array<Routemize_DTOs_BookingFormDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingForm/getAllForms',
            query: {
                'allowInstantBooking': allowInstantBooking,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppBookingFormPublishBookingForm(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/{id}/publishBookingForm',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppBookingFormUnpublishBookingForm(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/{id}/unpublishBookingForm',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppBookingFormArchiveBookingForm(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/{id}/archiveBookingForm',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_SlugAvailabilityDto OK
     * @throws ApiError
     */
    public static postApiAppBookingFormCheckSlugAvailability(
        requestBody?: Routemize_DTOs_CheckSlugAvailabilityRequest,
    ): CancelablePromise<Routemize_DTOs_SlugAvailabilityDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/checkSlugAvailability',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppBookingFormSetDirectoryListing(
        requestBody?: Routemize_DTOs_SetBookingFormDirectoryInput,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/setDirectoryListing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAppBookingFormGetFavoriteFormIds(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingForm/getFavoriteFormIds',
        });
    }
    /**
     * @param bookingFormId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppBookingFormToggleFavorite(
        bookingFormId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingForm/toggleFavorite/{bookingFormId}',
            path: {
                'bookingFormId': bookingFormId,
            },
        });
    }
}
